import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { AppActions, RootState } from "src/app/store";
import { SKIP_LOADER } from "./skip-loader.context";

@Injectable({ providedIn: "root" })
export class LoaderInterceptor implements HttpInterceptor {
  private readonly store = inject(Store<RootState>);
  private requestsCounter: number;

  constructor() {
    this.requestsCounter = 0;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.get(SKIP_LOADER)) return next.handle(req);
    this.store.dispatch(AppActions.showLoader());
    this.requestsCounter++;

    return next.handle(req).pipe(
      finalize(() => {
        this.requestsCounter--;

        if (!this.requestsCounter) this.store.dispatch(AppActions.hideLoader());
      }),
    );
  }
}
